import { AustralianState } from '@urbanx/agx-ui-components';
import { StaffApi } from 'helpers';

export const getSuburbs = async (
  authToken: string,
  query: string,
  state: AustralianState,
  signal: AbortSignal
) => {
  const { data } = await new StaffApi('rex', authToken).post(
    'GetSuburbs',
    {
      listName: 'suburbs',
      searchString: query,
      state,
    },
    {},
    {},
    signal
  );

  return data;
};
